import { memo } from 'react';

import { Badge } from '@components/badge';
import { IconCloseSmall } from '@components/icons/close-small';
import { useScopedTranslate } from '@locale/translate';

import { TravellerJourneyAction } from 'api/types';
import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { MoreItems, TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { getConditionDescription, getConditionTooltip } from './journey-node';

import { actionCardStyles, tagStyles } from '../condition-v2/traveller-node';

const ACTION_TYPE = ACTION_TYPES.condition;

export const getDescription = (action: TravellerJourneyAction<typeof ACTION_TYPE>): string => {
  return getConditionDescription({ values: action.values, styled: false }) as string;
};

export const Node = memo((node: TravellerJourneyNode<typeof ACTION_TYPE>) => {
  const { t } = useScopedTranslate(nodeLocale);

  const values = node.data?.values;

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        cardStyles={actionCardStyles}
        node={node}
        label={getActionLabel(ACTION_TYPE)}
        descriptionText={getConditionDescription({ values })}
        tooltip={getConditionTooltip({ values })}
        renderBelowDescription={
          <>
            <MoreItems items={values?.conditions} />
            {node.data.isHalted && node.data.isCompleted && (
              <Badge
                size="md"
                style={tagStyles}
                variant="indigo"
                icon={<IconCloseSmall />}
                text={t('conditionNotMet')}
              />
            )}
          </>
        }
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    conditionNotMet: 'Condition not met',
  },
};
